import { Link } from 'react-router-dom';

import { getWebUrl } from '@/lib/urls';
import { Button, Modal } from '@pptcreate/ui';

type UpgradeModalProps = {
  open: boolean;
  onClose: () => void;
};

export function UpgradeModal({ open, onClose }: UpgradeModalProps) {
  const pricingUrl = `${getWebUrl()}/pricing`;

  return (
    <Modal open={open} onClose={onClose} title="Free deck limit reached">
      <p className="text-sm text-brut-muted">
        You have used all 3 free decks on your plan. Upgrade to Unlimited to keep generating new
        presentations.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <a href={pricingUrl} className="no-underline">
          <Button variant="primary" size="md">Upgrade to Unlimited — $12/mo</Button>
        </a>
        <Link to="/decks" onClick={onClose} className="no-underline">
          <Button variant="secondary" size="md">Manage decks</Button>
        </Link>
        <Button type="button" variant="ghost" size="md" onClick={onClose}>
          Not now
        </Button>
      </div>
    </Modal>
  );
}
